import Resources from "shared/actions/resourcesActions";

// eslint-disable-next-line import/prefer-default-export
export default class AccountRolesResource extends Resources {
  constructor(dispatch) {
    super(dispatch, "account_role", "/api/v1/account/account_roles");
    this.refreshPageContentAfterCommit = true;
  }
}
